import { render, staticRenderFns } from "./VatRelations.vue?vue&type=template&id=31872ce6&scoped=true&"
import script from "./VatRelations.vue?vue&type=script&lang=js&"
export * from "./VatRelations.vue?vue&type=script&lang=js&"
import style0 from "./VatRelations.vue?vue&type=style&index=0&id=31872ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31872ce6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
